var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendercourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.94444H15M4.11111 1.5V3.05556M11.8889 1.5V3.05556M3.48889 15.5H12.5111C13.3823 15.5 13.8179 15.5 14.1507 15.3304C14.4433 15.1813 14.6813 14.9433 14.8304 14.6507C15 14.3179 15 13.8823 15 13.0111V5.54444C15 4.67325 15 4.23765 14.8304 3.9049C14.6813 3.6122 14.4433 3.37423 14.1507 3.2251C13.8179 3.05556 13.3823 3.05556 12.5111 3.05556H3.48889C2.6177 3.05556 2.1821 3.05556 1.84935 3.2251C1.55665 3.37423 1.31868 3.6122 1.16955 3.9049C1 4.23765 1 4.67325 1 5.54444V13.0111C1 13.8823 1 14.3179 1.16955 14.6507C1.31868 14.9433 1.55665 15.1813 1.84935 15.3304C2.1821 15.5 2.61769 15.5 3.48889 15.5Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendercourse);
export default __webpack_public_path__ + "static/media/calendercourse.0d6ac037b825351a91787f01dd6c6f21.svg";
export { ForwardRef as ReactComponent };